/**
 * Date / time formatting utilities for grid columns.
 * Feature 039: US3 — UpdatedAt relative time display.
 */

/**
 * Format a date as relative time (e.g. "3 days ago") with Intl.RelativeTimeFormat.
 * Returns a tuple of [relativeLabel, absoluteLabel] suitable for title tooltip.
 */
export function formatRelativeTime(date: string | DateTimeOffset): [string, string] {
  const d = new Date(date);
  const absolute = d.toLocaleString(undefined, {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });

  const diffMs = d.getTime() - Date.now();
  const diffSec = Math.round(diffMs / 1000);
  const abs = Math.abs(diffSec);

  const rtf = new Intl.RelativeTimeFormat('en', { numeric: 'auto' });

  if (abs < 60) return [rtf.format(diffSec, 'second'), absolute];
  if (abs < 3600) return [rtf.format(Math.round(diffSec / 60), 'minute'), absolute];
  if (abs < 86400) return [rtf.format(Math.round(diffSec / 3600), 'hour'), absolute];
  if (abs < 2592000) return [rtf.format(Math.round(diffSec / 86400), 'day'), absolute];
  if (abs < 31536000) return [rtf.format(Math.round(diffSec / 2592000), 'month'), absolute];
  return [rtf.format(Math.round(diffSec / 31536000), 'year'), absolute];
}

// Type alias kept narrow — only string ISO dates are expected from the API.
type DateTimeOffset = string;
